const articleProyect = (
  length,
  index,
  img,
  title,
  age,
  copy,
  technologies,
  urlCode,
  urlDemo
) => `
<article class='mt-6 h-50 ${index % 2 === 1 ? 'reverse' : ''} '>
    <div class="justify-content-center w-50 ">
        <img src="${img}" alt="Proyect ${title}">
    </div>
    <section class='w-50'>
        <h4>${title}<span class='ml-1'>${age}</span></h4>
        <p  class='mt-2'>${copy}</p>
        <section class='content-tab justify-content-center mt-4'>
            ${technologies
    .map(
      (technologie) =>
        `<i class='tab ${technologie}'>${technologie}</i>`
    )
    .join('')}
        </section>
        <div class="row justify-content-center mt-4 article-link">
            <a href="${urlCode}" target='_black' rel="noopener">Code</a>
            <a href="${urlDemo}" target='_black' rel="noopener">Demo</a>
        </div>
    </section>
</article>
${length - 1 !== index
    ? `
    <div class="justify-content-center ">
        <hr class='mt-6'/>
    </div>`
    : ''
  }`

export default articleProyect
